export default __webpack_public_path__ + "static/media/26.e1e93934.png";